export class CanvasPoint {
  constructor(
    public x: number,
    public y: number,
  ) {}
}
